import React, { useState } from "react";
import "./Login.scss";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate(); // Use the hook

    const handleLogin = (e) => {
        e.preventDefault();

        // Validate inputs
        if (!email.length > 4) {
            setError("Please enter a valid email address.");
            return;
        }
        if (password.length < 6) {
            setError("Password must be at least 6 characters long.");
            return;
        }

        setError("");

        // Handle API call for login
        console.log("Login submitted:", { email, password });
        const body = {
            username: email,
            password: password
        }
        loginApi(body);
        // Simulate API call

        // Add your API integration here
    };

    const loginApi = async (body) => {
        try {
            const response = await axios.post("https://api.appmingleconsultants.com/login/", body);
            console.log(response);
            const token = response.data?.access; // Accessing the token correctly
            if (token) {
                localStorage.setItem("sessionId", token); // Store the token in localStorage
                navigate("/list"); // Navigate to the desired route
            } else {
                setError("Login failed. Access token not received.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setError('Error fetching data');
        }
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <h1 className="login-title">Login</h1>
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label htmlFor="email">Email Id</label>
                        <input
                            type="text"
                            id="email"
                            placeholder="Enter your Email Id"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="login-button">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
